module.exports = function ($scope, $location, pageMetaDataService, $state, $injector, $rootScope) {
    this.metaData = pageMetaDataService;

    this.currentUrl = function () {
        return $location.absUrl();
    };

    this.canonicalUrl = '';

    this.setCanonicalUrl = function () {
        const paramsCanonicalUrl = $state.current.data ? $state.current.data.canonicalUrl : undefined;
        //If multiple values of single filter or multiple filters are applied then set noIndex tag
        let setNoIndexForFilters = $state.params.filters && $state.params.filters.split(',') && ($state.params.filters.split(',').length > 1);
        if (($location.absUrl().toLowerCase().indexOf('productgroup') !== -1 ||
            $location.absUrl().toLowerCase().indexOf('search') !== -1) && $state.params.filters) {
            setNoIndexForFilters = true;
        }
        if (paramsCanonicalUrl) {
            $injector.invoke(paramsCanonicalUrl).then((url) => {
                this.canonicalUrl = url;
            });
        } else {
            if (setNoIndexForFilters) {
                this.canonicalUrl = pageMetaDataService.getNormalizedCanonicalUrl();
            } else {
                const url = $location.absUrl();
                let baseUrl = url.indexOf('?') === -1 ? url : url.split('?')[0];
                const params = url.indexOf('?') === -1 ? '' : url.split('?')[1];
                let filters = '';
                if (params) {
                    filters = params.indexOf('filters') === -1 ? '' : params.split('filters')[1];
                    if (filters) {
                        filters = filters.indexOf('&') === -1 ? filters : filters.split('&')[0];
                        baseUrl = baseUrl + '?filters' + filters;
                    }
                }
                this.canonicalUrl = baseUrl;
            }
        }
    };

    this.noIndex = false;
    this.setNoIndex = function () {
        //If multiple values of single filter or multiple filters are applied then set noIndex tag
        let setNoIndexForFilters = $state.params.filters && $state.params.filters.split(',') && ($state.params.filters.split(',').length > 1);
        if (($location.absUrl().toLowerCase().indexOf('productgroup') !== -1 ||
            $location.absUrl().toLowerCase().indexOf('search') !== -1) && $state.params.filters) {
            setNoIndexForFilters = true;
        }
        if (($state.current.data && $state.current.data.noIndex) || setNoIndexForFilters || $state.params.sortby) {
            this.noIndex = true;
        } else {
            this.noIndex = false;
        }
    };

    this.setPrerenderStatus = function () {
        const stateData = $state.current.data || $state.$current.data;

        if (stateData && stateData.prerender) {
            this.prerender = stateData.prerender;
        } else {
            this.prerender = {};
        }
    };

    $rootScope.$on('$stateChangeSuccess', () => {
        this.setCanonicalUrl();
        this.setNoIndex();
        this.setPrerenderStatus();
        this.state = $state.current.name;
    });

    $scope.$watchCollection(() => {
        return $state.params;
    }, () => {
        this.setNoIndex();
    });

    $scope.$watchCollection(() => {
        return $state.params;
    }, () => {
        this.setCanonicalUrl();
    });

    $scope.$watchCollection(() => {
        return $state.current.data;
    }, () => {
        this.setNoIndex();
    });

    $scope.$watchCollection(() => {
        return $state.$current.data;
    }, () => {
        this.setPrerenderStatus();
    });
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/pagemetadata/page-metadata-controller.js
 **/